import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { VerificationInfo } from 'webapp/utils/verification';

import visibleCheckItem from 'webapp/modifiers/visible-check-item';
import BoardImagePreviewComponent from 'webapp/components/board/image-preview';
import ScrollableTextComponent from 'webapp/components/scrollable-text';
import VerificationBadgeComponent from 'webapp/components/verification/badge';

import type Board from 'webapp/models-custom/board';
import type BoardLoop from 'webapp/models-custom/board-loop';

interface Args {
	model: Board | BoardLoop;
	selected: Board | BoardLoop | null;
	onChange: (board: Board | BoardLoop) => void;
}

export default class DesignerTopbarDataboardSelectListItemComponent extends Component<Args> {
	@tracked isVisibleOnScreen = false;

	get isSelected(): boolean {
		return this.args.model.id === this.args.selected?.id;
	}

	get verificationInfo(): VerificationInfo | undefined {
		return 'verificationInfo' in this.args.model ? this.args.model.verificationInfo : undefined;
	}

	@action
	selectionChanged(): void {
		this.args.onChange(this.args.model);
	}

	@action
	visibleChanged(isVisible: boolean): void {
		this.isVisibleOnScreen = isVisible;
	}
	<template>
		{{#if this.isVisibleOnScreen}}
			<li class="board {{if this.isSelected 'selected'}}">
				<a role="button" {{on "click" this.selectionChanged}}>
					<div class="border">
						<BoardImagePreviewComponent
							@image={{@model.image}}
							@color={{@model.color}}
							@theme={{@model.bgTheme}}
						/>
					</div>
				</a>
				<div class="board-name">
					<ScrollableTextComponent>
						{{@model.name}}
					</ScrollableTextComponent>
					<VerificationBadgeComponent
						@verification={{this.verificationInfo}}
						@entityLabel="databoard"
						@size="sm"
					/>
				</div>
			</li>
		{{else}}
			<li
				class="board {{if this.isSelected 'selected'}}"
				{{visibleCheckItem this.visibleChanged}}
			>
				<div class="board-name">{{@model.name}}</div>
			</li>
		{{/if}}
	</template>
}
